(function() {
    setInterval(function() {
        let lyvecom_count_split = $('.lyvecom-custom-carousel-header').find('h2').text().split(',');
        let lyvecom_concat = lyvecom_count_split[0].concat('', lyvecom_count_split[1], lyvecom_count_split[2]);
        let lyvecom_count_to_int = parseInt(lyvecom_concat);
        let new_count = lyvecom_count_to_int + 1;
        let new_count_to_string = new_count.toString();
        let new_count_split = new_count_to_string.split('');
        new_count_split.splice(1, 0, ',')
        new_count_split.splice(5, 0, ',')
        let new_count_join = new_count_split.join('');
        $('.lyvecom-custom-carousel-header').find('h2').html(`${new_count_join}`);
    }, 50000);
}());